import React, { useState } from 'react';
import { Icon } from '@ann/web-components';
import { Container, Header, List, Item, Index, Link } from './SourcesCitation.styled';

/**
 * SourcesCitation - Collapsible sources list with indexed [1], [2] references.
 */
const SourcesCitation = ({ sources = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!sources.length) return null;

  return (
    <Container>
      <Header type="button" onClick={() => setIsExpanded((prev) => !prev)} aria-expanded={isExpanded}>
        <Icon
          name={isExpanded ? 'chevronDown' : 'chevronRight'}
          size="small"
          color="neutral"
        />
        Sources ({sources.length})
      </Header>
      {isExpanded && (
        <List>
          {sources.map((src, i) => (
            <Item key={src.url ?? src.title ?? i}>
              <Index>[{i + 1}]</Index>
              {src.url ? (
                <Link href={src.url} target="_blank" rel="noopener noreferrer">
                  {src.title ?? src.url}
                </Link>
              ) : (
                <span>{src.title ?? 'Source'}</span>
              )}
            </Item>
          ))}
        </List>
      )}
    </Container>
  );
};

export default SourcesCitation;
